import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

const Hero = ({ className, children, layout }) => {
  const customClassName = classNames('hero', className, `-${layout}`);
  return (
    <section className={customClassName}>
      <div className="hero-container">{children}</div>
    </section>
  );
};

Hero.propTypes = {
  className: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'grid', 'vertical']),
  children: PropTypes.node,
};

Hero.defaultProps = {
  layout: 'horizontal',
  className: '',
  children: null,
};

export default Hero;
